import { MultipleSelectOption } from '..';

export function toggleOptionInSelection(
  selectedValues: string[],
  optionValue: string,
): string[] {
  const isSelected = selectedValues.includes(optionValue);

  if (isSelected) {
    return selectedValues.filter(
      (selectedValue) => selectedValue !== optionValue,
    );
  }

  return [...selectedValues, optionValue];
}

export function getTriggerLabels(
  value: string[],
  options: MultipleSelectOption[],
  placeholder: string,
  activeSelectAllOption?: MultipleSelectOption,
) {
  if (activeSelectAllOption) {
    return {
      ariaLabel: activeSelectAllOption.name,
      displayText: activeSelectAllOption.name,
    };
  }

  const selectedNames = value
    .map(
      (selectedValue) =>
        options.find((option) => option.value === selectedValue)?.name,
    )
    .filter((name): name is string => Boolean(name));

  if (!selectedNames.length) {
    return { ariaLabel: placeholder, displayText: placeholder };
  }

  if (selectedNames.length === 1) {
    return {
      ariaLabel: selectedNames[0],
      displayText: selectedNames[0],
    };
  }

  const count = selectedNames.length;

  return {
    ariaLabel: `${count} selected`,
    displayText: `${count} selected`,
  };
}

export function getListboxOptionState(
  option: MultipleSelectOption,
  value: string[],
  isSelectAllActive: boolean,
): { isSelected: boolean; disabled: boolean } {
  const disabled = isSelectAllActive && !option.selectAll;
  const isSelected =
    value.includes(option.value) || (isSelectAllActive && !option.selectAll);

  return { disabled, isSelected };
}

export function shouldShowListboxDivider(
  option: MultipleSelectOption,
  index: number,
  optionsLength: number,
): boolean {
  return Boolean(option.divider && index < optionsLength - 1);
}
